import React from 'react';

const POSFooter = () => {
    return (
        <div className="pos-footer">
            © 2026 Chenthoor Restaurant Management System
        </div>
    );
};

export default POSFooter;